<template>
  <div>
    <div class="base-card mb-3">
      <div
        class="card-body"
        style="padding: 0px;"
      >
        <div class="university-cell">
          <div class="row no-gutters">
            <div
              :class="'col-md-1 check-part pt-2 '+(selected?'check-part-checked':'')"
              :disabled="waiting_for_request"
              style="text-align: center;"
              @click="selectUniversity"
            >
              <fa-icon
                v-if="!selected"
                :icon="['far', 'square']"
                class="icon-check-university"
              />
              <fa-icon
                v-if="selected"
                icon="check-square"
                class="icon-check-university icon-check-university-selected"
              />
            </div>
            <div class="col-md-7">
              <div
                class="card-body"
                style="padding: 10px"
              >
                <h5 class="card-title">
                  {{ university.institution_branch.institution.official_name }}
                </h5>
                <div class="text-muted">
                  {{ university.career_name | lowercase | capitalize }}
                </div>
                <div class="university-cell__region">
                  Región {{ university.region_name || '' | capitalize }}
                </div>
                <div
                  v-if="university.observation"
                  class="university-cell__region"
                >
                  (*){{ university.observation }}
                </div>
                <div class="d-none d-sm-flex d-md-none w-100 row">
                  <div class="col-6">
                    <div class="row">
                      <div class="text-muted col-6">
                        Costo total aprox.
                      </div>
                      <h6 class="col-6">
                        {{ costoTotal }}
                      </h6>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col-6 text-muted">
                        Duración formal aprox.
                      </div>
                      <h6 class="col-6">
                        {{ duracionFormal }}
                      </h6>
                    </div>
                  </div>
                </div>
                <!-- Screen < sm -->
                <div class="d-block d-sm-none w-100">
                  <p
                    class="m-0"
                    style="font-size: 12px;"
                  >
                    Costo total aprox.: <b>{{ costoTotal }}</b>
                  </p>
                  <p
                    class="m-0"
                    style="font-size: 12px;"
                  >
                    Duración formal: <b>{{ duracionFormal }}</b>
                  </p>
                </div>
                <div class="d-flex row d-sm-none">
                  <CollapseLink
                    id="pruebas"
                    class="col-12"
                    title="Pruebas"
                    :show-detail="showDetails['pruebas']"
                    @click-collapse-link="toggleDetails"
                  />
                  <Pruebas
                    v-if="showDetails['pruebas']"
                    class="col-12"
                    :grades-by-career="university.grades_by_career"
                  />

                  <CollapseLink
                    id="curriculum"
                    class="col-12"
                    title="Curriculum"
                    :show-detail="showDetails['curriculum']"
                    @click-collapse-link="toggleDetails"
                  />
                  <Curriculum
                    v-if="showDetails['curriculum']"
                    :curriculum="{
                      Cualitativo: university.cualitative,
                      Cuantitativo: university.cuantitative,
                      Profesional: university.professional,
                      Electivo: university.optional,
                    }"
                    :hours="{
                      teoricas: university.hrs_the,
                      practicas: university.tot_cre,
                      creditos: university.tot_cre,
                      ciclos: university.tot_cyc,
                    }"
                    :link="university.institution_branch.institution.link"
                    class="col-12"
                  />

                  <CollapseLink
                    id="contacto"
                    class="col-12"
                    title="Contacto"
                    :show-detail="showDetails['contacto']"
                    @click-collapse-link="toggleDetails"
                  />
                  <Contacto
                    v-if="showDetails['contacto']"
                    class="col-12"
                    :data="university.institution_branch"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2 d-none d-lg-block">
              <div class="card-body">
                <div class="text-muted">
                  <small class="text-nowrap">Costo total aprox.</small>
                </div>
                <h5 class="card-title">
                  {{ costoTotal }}
                </h5>
              </div>
            </div>
            <div class="col-md-2 d-none d-lg-block">
              <div class="card-body">
                <div class="text-muted">
                  <small>Duración formal aprox.</small>
                </div>
                <h5 class="card-title">
                  {{ duracionFormal }}
                </h5>
              </div>
            </div>
            <!-- thin screen -->
            <div class="d-none d-md-block d-lg-none m-2">
              <div class="text-muted">
                Costo total aprox.
              </div>
              <h5 class="card-title text-nowrap">
                {{ costoTotal }}
              </h5>
              <div class="text-muted text-nowrap">
                Duración formal aprox.
              </div>
              <h5 class="card-title">
                {{ duracionFormal }}
              </h5>
            </div>
            <div class="row col-12">
              <div class="col-12 mx-3 d-none d-sm-block border-top py-3">
                <CollapseLink
                  id="desktopInfo"
                  title="Más información"
                  :show-detail="showDetails['desktopInfo']"
                  class="more_info"
                  @click-collapse-link="toggleDetails"
                />
              </div>
              <div
                v-if="showDetails['desktopInfo']"
                class="d-none d-sm-block col-12"
              >
                <div class="p-4 row">
                  <div class="university-cell__tabs col-12">
                    <base-tabs
                      :current-tab="currentTab"
                      :tabs="['Pruebas', 'Pensum', 'Contacto']"
                      @change-current-tab="changeCurrentTab"
                    />
                  </div>
                  <div class="p-2 row">
                    <template v-if="currentTab == 0">
                      <Pruebas :grades-by-career="university.grades_by_career" />
                    </template>
                    <template v-if="currentTab == 1">
                      <Curriculum
                        :curriculum="{
                          Cualitativo: university.cualitative,
                          Cuantitativo: university.cuantitative,
                          Profesional: university.professional,
                          Electivo: university.optional,
                        }"
                        :hours="{
                          teoricas: university.hrs_the,
                          practicas: university.tot_cre,
                          creditos: university.tot_cre,
                          ciclos: university.tot_cyc,
                        }"
                        :link="university.institution_branch.institution.link"
                      />
                    </template>
                    <template v-if="currentTab == 2">
                      <Contacto :data="university.institution_branch" />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CollapseLink from './CollapseLink.vue';
import Contacto from './Contacto.vue';
import Curriculum from './Curriculum.vue';
import Pruebas from './Pruebas.vue';

export default {
    name: 'UniversityCell',
    components: {
        CollapseLink,
        Contacto,
        Curriculum,
        Pruebas,
    },
    props: ['index', 'university'],
    data() {
        return {
            waiting_for_request: false,
            selected: this.university.checked,
            showDetails: {
                pruebas: false,
                curriculum: false,
                contacto: false,
                desktopInfo: false,
            },
            currentTab: 0,
        };
    },
    computed: {
        costoTotal() {
            const costo = this.university.total_cost;
            const { observation } = this.university;
            return !(costo === 'nan') ? `${costo} RD$ ${observation ? '(*)' : ''}` : 'Sin datos';
        },
        duracionFormal() {
            const duracion = this.university.real_duration;
            return duracion ? `${duracion} años` : 'Sin datos';
        },
    },
    mounted() {
        this.$root.$on('UniversityCell::showDetail', () => {
            this.showDetails.pruebas = false;
            this.showDetails.curriculum = false;
            this.showDetails.contacto = false;
            this.showDetails.desktopInfo = false;
        });
    },
    methods: {
        changeCurrentTab(tab) {
            this.currentTab = tab;
        },
        selectUniversity() {
            const selected = !this.selected;
            this.emitSelect();
            this.selected = selected;
        },
        toggleDetails(val) {
            this.showDetails[val] = !this.showDetails[val];
        },
        emitSelect() {
            if (!this.selected) {
                this.$store.dispatch('clippyNotifications/selectUniversity', this.university.id);
            }
            // Emit the opposite value because this triggers before the value change
            this.$emit('select', !this.selected, this.index, this.university.id);
        },
    },
};
</script>

<style lang="scss">
  .check-part {
    border-top-left-radius: 10px;
    border-right: solid 1px #ccc;
  }
  .check-part-checked {
    background-color: #4A90E2 !important;
  }
  .icon-check-university {
    cursor: pointer;
    font-size: 30px;
    position: relative;
    top: calc(50% - 20px);
  }
  .icon-check-university-selected {
    color: white;
  }
  .university-cell{
    border: solid 1px #ccc;
    transition: all 0.3s;
    border-radius: 10px;
    &__title{
      font-size: 0.9rem;
      margin-bottom: 1rem;
      line-height: 1.2;
      @media (min-width: 568px) {
        font-size: 1.2rem;
        line-height: 1;
      }
    }
    &__region{
      font-size: 0.8rem;
      opacity: 0.5;
      // margin-bottom: -0.1rem;
    }
    &__label{
      min-width: 100px;
      font-size: 0.8rem;
    }
    &__value{
      font-size: 0.8rem;
      font-weight: bold;
    }
    &__tabs{
      font-size: 0.75rem;
      @media (min-width: 568px) {
        font-size: 1rem;
      }
    }
  }
  .more_info{
    background-color: #4A90E2;
    color: white;
    border-radius: 30px;
    padding: 10px;
    text-align: center;
  }
  .more_info:hover{
    color: #eee;
  }
  .more_info small{
    font-size: 20px;
  }
</style>
